// removed by extract-text-webpack-plugin
module.exports = {"header":"src-components----header-module---header---2Q3RK","active":"src-components----header-module---active---326IL","logo":"src-components----header-module---logo---3gu8x"};


//////////////////
// WEBPACK FOOTER
// ./src/components/header.module.css
// module id = 131
// module chunks = 35783957827783 213720915766396